export default "__VITE_ASSET__CHr$$zz$__"